"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var pad = function pad(number, expectedDigits) {
  return "".concat(number).padStart(expectedDigits, '0');
};

var _default = pad;
exports["default"] = _default;